export enum StorageKey {
  OnboardingTooltipStep = "onboardingTooltipStep",
}

export interface StorageSchema {
  [StorageKey.OnboardingTooltipStep]: number;
}
